import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { ErrorMessage, Field, Form, Formik } from 'formik';
import { FieldTypes } from 'drapcode-constant';
import {
  customConstraintSchema,
  customConstraintSchemaValidation,
} from '../../../../common/custom/constraint-validation';
import { moveDefaultCollectionFieldsToEndAndSort } from '../../../../common/utils/api_utils';
import CustomLoader from '../../../common/CustomLoader';
import { default as CollectionSelect } from '../../../home/collections/CustomSelect';
import CustomSelect from '../../../../common/formElements/CustomSelect';
import { drapcodeIcon, iconForField } from '../../../../common/custom/icon-library';

export default class ConstraintForm extends Component {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    constraintType: PropTypes.string,
    constraint: PropTypes.object,
    isCollection: PropTypes.bool,
  };

  state = {
    constraintType: this.props.constraintType,
    fields: [],
    constraintTypes: [{ value: 'COMPOSITE', label: 'Composite Key' }],
  };

  getAllAllowedFieldForSelect = () => {
    const { collection } = this.props;
    const { fields } = collection;
    if (fields.length > 0) {
      let filteredFields = fields.filter((item) => {
        return FieldTypes[item.type].compositeKey && !item.isMultiSelect;
      });
      return moveDefaultCollectionFieldsToEndAndSort(filteredFields).map((field) => ({
        value: field.fieldName,
        label: field.fieldTitle.en,
      }));
    } else {
      return [];
    }
  };

  clearForm = () => {
    customConstraintSchema.constraintType = '';
    customConstraintSchema.name = '';
    customConstraintSchema.fields = [];
    this.setState({ constraintType: null });
  };

  handleSubmit = (values) => {
    values.constraintType = this.state.constraintType;
    this.props.handleSubmit(values);
    if (!this.props.isCollection) {
      this.setState({ fields: [] });
    }
  };

  handleChange = (name, value) => {
    this.setState({ [name]: value });
  };

  createCustomFieldForValue = (setFieldValue, setFieldTouched, values) => {
    const { constraintType } = this.state;
    if (!constraintType) {
      return '';
    }

    return (
      <div className="form-group">
        <div className="input-group">
          <div className="input-group-prepend" title={'Fields'}>
            <span className="input-group-text">
              <i className={`wb ${iconForField('select')}`}></i>
              <span className="required"> *</span>
            </span>
          </div>
          <CollectionSelect
            name={'fields'}
            value={values['fields']}
            isMulti={true}
            options={this.getAllAllowedFieldForSelect()}
            onChange={setFieldValue}
            onBlur={setFieldTouched}
            onChangeValue={this.handleChange}
          />
          <ErrorMessage name="fields">{(msg) => <p className="text-error">{msg}</p>}</ErrorMessage>
        </div>
      </div>
    );
  };
  //TODO: Refactor to common component
  render() {
    const { constraint, isCollection, showDerivedConstraintLoader } = this.props;
    customConstraintSchema.name = constraint ? constraint.name : '';
    customConstraintSchema.fields = constraint ? constraint.fields : '';
    customConstraintSchema.constraintType = constraint ? constraint.constraintType : '';
    return (
      <>
        <Formik
          initialValues={customConstraintSchema}
          validationSchema={customConstraintSchemaValidation}
          onSubmit={(values, { setSubmitting, resetForm }) => {
            this.handleSubmit(values);
            if (!isCollection) {
              setSubmitting(false);
              this.clearForm();
              resetForm();
            }
          }}
        >
          {({ isSubmitting, setFieldValue, setFieldTouched, resetForm, values }) => {
            return (
              <Form className="form-horizontal">
                <div className="row mx-auto">
                  <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12">
                    <div className="form-group">
                      <div className="input-group">
                        <div className="input-group-prepend" title="Constraint Name">
                          <span className="input-group-text">
                            <i className={`wb ${iconForField('text')}`}></i>
                            <span className="required"> *</span>
                          </span>
                        </div>
                        <Field
                          type="text"
                          name="name"
                          className="form-control form-control-sm"
                          placeholder="Name of Constraint"
                        />
                        <ErrorMessage name="name">
                          {(msg) => <p className="text-error">{msg}</p>}
                        </ErrorMessage>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12">
                    <div className="form-group">
                      <div className="input-group">
                        <div className="input-group-prepend" title="Constraint Type">
                          <span className="input-group-text">
                            <i className={`wb ${iconForField('select')}`}></i>
                            <span className="required"> *</span>
                          </span>
                        </div>
                        <CustomSelect
                          name="constraintType"
                          isMulti={false}
                          value={this.state.constraintType}
                          options={this.state.constraintTypes}
                          onChange={setFieldValue}
                          onBlur={setFieldTouched}
                          onChangeValue={this.handleChange}
                        />

                        <ErrorMessage name="constraintType">
                          {(msg) => <p className="text-error">{msg}</p>}
                        </ErrorMessage>
                        <div className="input-group-append">
                          <span
                            className="input-group-text"
                            data-tip="Type of constraint"
                            title="Type of constraint"
                          >
                            <i className={`wb ${drapcodeIcon('description')}`}></i>
                          </span>
                        </div>
                      </div>
                      <small style={{ marginLeft: '5%' }}>Type of constraint</small>
                    </div>
                  </div>
                  <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12">
                    {this.createCustomFieldForValue(setFieldValue, setFieldTouched, values)}
                  </div>
                  <div className="col-md-12 col-lg-12 text-right">
                    {!constraint ? (
                      <button
                        type="button"
                        className="btn btn-default btn-md"
                        onClick={() => {
                          resetForm();
                          this.clearForm();
                        }}
                      >
                        <span>
                          <i className="wb webconnect-eraser"></i>&nbsp;Clear
                        </span>
                      </button>
                    ) : (
                      ''
                    )}
                    &nbsp;
                    <button
                      type="submit"
                      className="btn btn-theme-submit btn-md"
                      disabled={isSubmitting && showDerivedConstraintLoader ? 'disabled' : ''}
                    >
                      <i
                        className={`wb ${
                          !constraint ? 'webconnect-plus' : 'webconnect-save-regular'
                        }`}
                      ></i>
                      &nbsp;
                      {!constraint ? 'Create' : 'Update'}&nbsp;
                      <CustomLoader loading={showDerivedConstraintLoader} />
                    </button>
                  </div>
                </div>
              </Form>
            );
          }}
        </Formik>
      </>
    );
  }
}
